import { PublicDownloadLinkModel } from "../models/PublicDownloadLinkModel";
import { PublicDownloadLinkRequestModel } from "../models/PublicDownloadLinkRequestModel";
import { ApiService } from "./ApiService";
import { IPublicDownloadLinkApiService } from "./IPublicDownloadLinkApiService";

export class PublicDownloadLinkApiService extends ApiService
    implements IPublicDownloadLinkApiService {
    constructor(baseUrl: string, language?: string) {
        super(baseUrl, language);
    }

    public generatePublicDownloadLink(
        fileId: number,
        publicLinkParams: PublicDownloadLinkRequestModel
    ): Promise<PublicDownloadLinkModel> {
        return this.post<PublicDownloadLinkModel>(`files/${fileId}/publiclinks`, publicLinkParams);
    }

    public getPublicLinkInfo(
        fileId: number,
        publicLinkId: string
    ): Promise<PublicDownloadLinkModel> {
        return this.get(`files/${fileId}/publiclinks/${publicLinkId}`);
    }

    public deletePublicLink(fileId: number, publicLinkId: string): Promise<any> {
        return this.delete(`files/${fileId}/publiclinks/${publicLinkId}`);
    }
}
